export const NEXT_LEVEL_DENIED = {
  Type: 'Feedback',
  SubType: 'Flex level completion',
  Subject: 'Flex level change not recommended',
  Description:
    'This is an automatic notification that the instructor has marked a student as not ready to continue with the next Flex level. Please review the progress of the program to evaluate next steps.',
  Priority: 'High',
}

export const TYPE = {
  FEEDBACK: 'Feedback',
}

export const SUB_TYPE = {
  FLEX_LVL_COMPLETION: 'Flex level completion',
}

export const PRIORITY = {
  HIGH: 'HIGH',
}

export const CONTACT_US = 'Contact us'

